import { render, staticRenderFns } from "./DirectCosts.vue?vue&type=template&id=6b007704"
import script from "./DirectCosts.vue?vue&type=script&lang=js"
export * from "./DirectCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports